export class TypeComposant {
    constructor(
        public id?: number,
        public idTypeComposant?: number,
        public nom?: string,
        public libelle?: string,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/type-composant.model.ts